export enum PhysicianWorkRelated {
    CAUSED_BY_EMPLOYMENT = "To occur",
    WORSENED_BY_EMPLOYMENT = "To worsen (already had the condition)",
    NOT_APPLICABLE = "N/A"
}